import { useLang } from "../../i18n/LanguageContext";

const featureKeys = ["legacy","compliance","engineers","support"];
const featureIcons = { legacy:"fa-certificate", compliance:"fa-shield-halved", engineers:"fa-user-gear", support:"fa-headset" };

export default function WhyChoose() {
  const { t } = useLang();

  return (
    <section id="whychoose" className="py-32 bg-[#111112] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage:"repeating-linear-gradient(0deg,#fff 0,#fff 1px,transparent 1px,transparent 60px),repeating-linear-gradient(90deg,#fff 0,#fff 1px,transparent 1px,transparent 60px)" }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-16 items-center">

          <div className="lg:col-span-5 space-y-6">
            <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.whychoose.label}</div>
            <h2 className="text-3xl sm:text-4xl font-black tracking-tight text-white uppercase leading-tight">{t.whychoose.title}</h2>
            <p className="text-zinc-400 text-sm leading-relaxed font-light">{t.whychoose.body}</p>
            <div className="flex flex-wrap gap-2 pt-1">
              {["UL","FM","NFPA","ISO 9001","CE","API","ASTM","EN"].map(s => (
                <span key={s} className="px-3 py-1 bg-white/5 border border-white/5 rounded text-[10px] font-black text-zinc-400 uppercase tracking-wider">{s}</span>
              ))}
            </div>
            <a href="#contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#F28C18] text-black text-xs font-black tracking-widest uppercase rounded hover:bg-white transition-all duration-300">
              <i className="fas fa-calendar-check" /> {t.whychoose.cta}
            </a>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {featureKeys.map(key => (
              <div key={key}
                className="p-6 bg-[#1A1A1C] rounded-xl border border-white/5 hover:border-[#F28C18]/30 transition-all space-y-3 group">
                <div className="w-10 h-10 rounded-lg bg-orange-500/10 text-[#F28C18] flex items-center justify-center group-hover:bg-[#F28C18] group-hover:text-black transition-all">
                  <i className={`fas ${featureIcons[key]} text-sm`} />
                </div>
                <h4 className="text-sm font-black text-white uppercase">{t.whychoose.features[key].title}</h4>
                <p className="text-xs text-zinc-500 leading-relaxed">{t.whychoose.features[key].desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
